export default "__VITE_ASSET__aTDEcdy9__"